<template>
	<div class="branch-wrap">
		<div class="branch-box-wrap" style="position: relative">
			<div class="add-branch">
				<el-button type="success" plain round @click="handlerAddCond">添加条件</el-button>
			</div>
			<div class="branch-box">
				<!--				<branch-action :actions="[{title:'并且'}]">-->
				<!--					<template #reference>-->
				<!--						<div class="add-branch">-->
				<!--							<el-button type="success" plain round>添加条件</el-button>-->
				<!--						</div>-->
				<!--					</template>-->
				<!--				</branch-action>-->

				<div class="col-box" v-for="(item,index) in _config.children||[]" :key="index">
					<flow-render :_config="item" :_parent="_config" :_index="index"
								 @del-node="handlerDelNode(index)"
								 @to-left="handlerTo(_config.children,index,-1)"
								 @to-right="handlerTo(_config.children,index,1)"
								 @node-click="(v)=>$emit('node-click',v)"
					></flow-render>
					<div class="top-left-cover-line" v-if="index===0"></div>
					<div class="bottom-left-cover-line" v-if="index===0"></div>
					<div class="top-right-cover-line" v-if="index===_config.children?.length-1"></div>
					<div class="bottom-right-cover-line" v-if="index===_config.children?.length-1"></div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import AddAction from './flow-action.vue'
import FlowAction from "@/components/flow/nodes/flow-action.vue";
import FlowRender from "@/components/flow/flow-render.vue";
import ConditionNode from "@/components/flow/nodes/condition-node.vue";

export default {
	name: 'BranchNode',
	props: {
		_config: {
			type: Object, default: () => ({})
		},
		_parent: {
			type: Object, default: () => ({})
		},
		_define: {
			type: Object, default: () => ({})
		},
		_index: {
			type: Number
		}
	},
	components: {
		ConditionNode,
		FlowRender,
		FlowAction,
		AddAction
	},
	setup(props) {
		const handlerAddCond = () => {
			props._config.children.push(
				{
					id: '_'+new Date().getTime().toString(),
					name: 'COND',
					params: {},
					children: []
				},
			)
		}
		const handlerDelNode = (index) => {
			props._config.children?.splice(index, 1)
			if (props._config.children?.length === 0) {
				props._parent.children.splice(props._index, 1)
			}
		}
		const handlerTo = (nodes, index, offset) => {
			const node = nodes[index]
			nodes[index] = nodes[index + offset];
			nodes[index + offset] = node
		}
		return {
			handlerAddCond,
			handlerDelNode,
			handlerTo

		}
	}
}
</script>

<style scoped lang="scss">
.add-branch {
	justify-content: center;
	padding: 0px 10px;
	position: absolute;
	top: 0px;
	left: 50%;
	transform: translateX(-50%);
	transform-origin: center center;
	z-index: 1;
	display: inline-flex;
	align-items: center;
}

.branch-wrap {
	display: inline-flex;
	width: 100%;
}

.branch-box-wrap {
	display: flex;
	flex-flow: column wrap;
	align-items: center;
	min-height: 200px;
	width: 100%;
	flex-shrink: 0;
}

.col-box {
	display: inline-flex;
	flex-direction: column;
	align-items: center;
	position: relative;
	background: #f6f8f9;
}

.branch-box {
	display: flex;
	overflow: visible;
	min-height: 180px;
	height: auto;
	border-bottom: 2px solid #ccc;
	border-top: 2px solid #ccc;
	position: relative;
	margin-top: 15px;
}

.branch-box .col-box::before {
	content: "";
	position: absolute;
	top: 0px;
	left: 0px;
	right: 0px;
	bottom: 0px;
	z-index: 0;
	margin: auto;
	width: 2px;
	height: 100%;
	background-color: rgb(202, 202, 202);
}

.top-left-cover-line, .top-right-cover-line {
	position: absolute;
	height: 3px;
	width: 50%;
	background-color: #f6f8f9;
	top: -2px;
}

.bottom-left-cover-line, .bottom-right-cover-line {
	position: absolute;
	height: 3px;
	width: 50%;
	background-color: #f6f8f9;
	bottom: -2px;
}

.top-left-cover-line {
	left: -1px;
}

.top-right-cover-line {
	right: -1px;
}

.bottom-left-cover-line {
	left: -1px;
}

.bottom-right-cover-line {
	right: -1px;
}
</style>
